<template>
    <div id="nav">
        <div id="nav-num">
            <!-- <div class="head">
        <div class="name">
          <div class="oimg">
            <img src="../assets/img/logo.png" alt />
          </div>
          <div class="spa">e博视智慧配电在线监测系统</div>
        </div>
        <div class="tatel" v-show="IsshowIf">
          <div class="miti"></div>
          <div class="mixin" v-if="IsshowIf">{{ title }}</div>
        </div>
      </div> -->

            <div>
                <keep-alive :include="home">
                    <router-view />
                </keep-alive>
            </div>

           
        </div>
    </div>
</template>
<script>
    import chainIndex from "../api/play";
    export default {
        name: "home",
        data() {
            return {
                home: ["about", "ova"],
                IsshowIf: true,

                //标题栏切换
                //   title: "---暂未选择任何回路---",
                //时间
                date: new Date(),
                current: 0,
                list: [{
                        id: 0,
                        data: "运行概览",
                        path: "/About",
                        img1: require("../assets/img/gailan_nor.png"),
                        img2: require("../assets/img/gailan_sel.png"),
                    },
                    {
                        id: 1,
                        data: "进线监测",
                        path: "/ova",
                        img1: require("../assets/img/shujujiance_nor.png"),
                        img2: require("../assets/img/shujujiance_sel.png"),
                    },
                    {
                        id: 2,
                        data: "一次图模",
                        path: "/FirstDiagram",
                        img1: require("../assets/img/yicitumo_nor.png"),
                        img2: require("../assets/img/yicitumo_sel.png"),
                    },
                    {
                        id: 3,
                        data: "事件记录",
                        path: "/Cinema",
                        img1: require("../assets/img/shijianjilu_nor.png"),
                        img2: require("../assets/img/shijianjilu_sel.png"),
                    },
                ],
            };
        },
        watch: {
            "$route.path": function (to) {
                switch (to) {
                    case "/About":
                        this.IsshowIf = true;
                        this.current = 0;
                        sessionStorage.setItem("isSelect", this.current);
                        break;
                    case "/ova":
                        this.current = 1;
                        this.IsshowIf = true;
                        sessionStorage.setItem("isSelect", this.current);

                        break;
                    case "/Cinema":
                        this.IsshowIf = false;
                        this.current = 3;
                        sessionStorage.setItem("isSelect", this.current);
                        break;
                    case "/FirstDiagram":
                        this.current = 2;
                        this.IsshowIf = true;

                        this.title = "山东鲁泰总览图";
                        sessionStorage.setItem("isSelect", this.current);
                        break;
                }
            },
            "this.title": function (n) {
                this.title = n;
                // console.log(n);
            },
        },
        created() {
            // this.routerClickNave();
            this.EmitItemAll();
        },

        mounted() {
            let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
            this.timer = setInterval(() => {
                _this.date = new Date(); // 修改数据date
            }, 1000);
            this.current = sessionStorage.getItem("isSelect") ?
                sessionStorage.getItem("isSelect") :
                "";
            if (this.$route.path == "/FirstDiagram") {
                // console.log(11111111111111);
                this.title = "山东鲁泰总览图";
            } else {
                this.appAll();
            }
        },

        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
            }
            window.sessionStorage.removeItem("isSelect");
        },
        methods: {
            // routerClickNave() {
            //   switch (this.$route.path) {
            //     case "/About":
            //       this.current = 0;
            //       this.IsshowIf = true;
            //       sessionStorage.setItem("isSelect", this.current);
            //       this.appAll();

            //       break;
            //     case "/Ova":
            //       this.current = 1;
            //       sessionStorage.setItem("isSelect", this.current);
            //       this.appAll();
            //       this.IsshowIf = true;
            //       break;
            //     case "/FirstDiagram":
            //       this.title = "山东鲁泰总览图";
            //       this.current = 2;
            //       sessionStorage.setItem("isSelect", this.current);
            //       this.IsshowIf = true;

            //       break;
            //     case "/Cinema":
            //       this.current = 3;
            //       sessionStorage.setItem("isSelect", this.current);
            //       this.IsshowIf = false;
            //       break;
            //   }
            // },

            addClass(index) {
                this.current = index ? index : 0;
                sessionStorage.setItem("isSelect", this.current);
            },
            //时间戳

            dateFormat(time) {
                var date = new Date(time);
                var year = date.getFullYear();
                var month =
                    date.getMonth() + 1 < 10 ?
                    "0" + (date.getMonth() + 1) :
                    date.getMonth() + 1;
                var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                // 拼接
                return year + "-" + month + "-" + day;
            },
            //时间
            timerdate(time) {
                var date = new Date(time);
                var hours =
                    date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                var minutes =
                    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                var seconds =
                    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                return hours + ":" + minutes + ":" + seconds;
            },

            //传递一个默认选中回路
            appAll() {
                chainIndex
                    .analogInterface(this.$store.state.proproT.AllId)
                    .then((res) => {
                        console.log(res.data.data.deviceLoops[0]);
                        //   this.title = res.data.data.deviceLoops[0].loopName;
                        //进网页的初始值也是初始第一个订阅号
                        this.$store.commit(
                            "MutLoopUrl",
                            res.data.data.deviceLoops[0].subLoopUrl
                        );
                        this.$store.commit("LoopUrlTS", res.data.data.deviceLoops[0].loopUrl);
                    });
            },

            //传递选中回路信息
            EmitItemAll() {
                this.$root.eventHub.$on("YOUR_EVENT_NAME", (yourData) => {
                    // console.log(yourData);
                    this.title = yourData.loopName;
                });
            },
        },
    };
</script>
<style lang="less" scoped>
    #nav-num {
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        //   align-items: center;
        height: 100vh;
    }

    #nav {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .num {
            // position: fixed;
            // left: 0;
            // bottom: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            background-image: url(../assets/img/bgc.png);
            // z-index: 1;
        }

        .timerNav {
            width: 373rem;
            display: flex;
            line-height: 26rem;
            padding: 0 0 0 65rem;

            .year {
                // width: 110rem;
                height: 24rem;
                font-size: 24rem;
                font-weight: 400;
                color: #ffffff;
            }

            .time {
                margin-left: 34rem;
                width: 90rem;
                height: 18rem;
                font-size: 24rem;
                font-weight: 400;
                color: #ffffff;
            }
        }

        .home-item {
            display: flex;
            font-weight: bold;
            color: #2c3e50;
        }

        .home-click {
            width: 268rem;
            height: 68rem;
            font-size: 24rem;
            font-weight: 300;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            text-shadow: 0rem 1rem 2rem rgba(14, 5, 10, 0.6);

            //  background-image: url(../assets/img/613ju.png);
            .displayhome {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }

        .bgColors {
            width: 268rem;
            height: 68rem;
            background-image: linear-gradient(rgba(31, 29, 29, 0.6); rgba(137, 141, 145, 0.5); rgba(31, 29, 29, 0.6));
            // box-shadow:90rem 50rem 100rem #020202;
            box-shadow: 3rem 4rem 5rem #020202, -2rem 4rem 12rem #020202;
            background-repeat: no-repeat;
            background-size: cover;
        }

        .Oim {
            width: 38rem;
            height: 38rem;
            margin-right: 8rem;
        }
    }
</style>